import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "../views/login.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
 
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue')
  },
  {
    path: '/forgetpassword',
    name: 'forgetpassword',
    component: () => import('../views/forgetpassword.vue')
  },
  {
    path: '/chatgpt',
    name: 'chatgpt',
    component: () => import('../views/chatgpt.vue')
  },
  {
    path: '/zhongzhuan',
    name: 'zhongzhuan',
    component: () => import('../views/zhongzhuan.vue')
  },

  
 
]

const router = new VueRouter({
  routes
})

export default router
